<template>
  <div>
    
    <!-- Training Center -->
    <div class="widget-tc">
      <div class="container container-line">
        <div class="widget-tc-content">
          <div class="widget-tc-box">
            <img v-if="row.image5" :src="row.image5" class="img-fluid" :alt="row.title5" />
            <div class="tc-details">
              <div class="sub-title mb-2 gray-color"
                  v-html="row.subTitle5"
                  :style="'color:'+row.subTitleColor5+' !important'">
              </div>
              <div class="bg-title white-color mb-3"
                  v-html="row.title5"
                  :style="'color:'+row.color5+' !important'">
              </div>
              <div class="text  mb-2"
                  v-html="row.content5"
                  :style="'color:'+row.contentColor5+' !important'">
              </div>
              <router-link v-if="row.button5" :to="row.redirect5"
                class="btn-line btn-line-white">{{ row.button5 }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="widget-tc">
      <div class="container">
        <div class="widget-tc-content">
          <div class="widget-tc-box">
            <img v-if="row.image6" :src="row.image6" class="img-fluid" :alt="row.title6" />
            <div class="tc-details">
              <div class="sub-title mb-2 gray-color"
                  v-html="row.subTitle6"
                  :style="'color:'+row.subTitleColor6+' !important'">
              </div>
              <div class="bg-title main-color mb-3"
                  v-html="row.title6"
                  :style="'color:'+row.color6+' !important'">
              </div>
              <div class="text  mb-2"
                  v-html="row.content6"
                  :style="'color:'+row.contentColor6+' !important'">
              </div>
              <router-link v-if="row.button6" :to="row.redirect6"
                class="btn-line">{{ row.button6 }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Training Center -->

  </div>
</template>

<script>
export default {
  name: "Section3",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
  mounted () {
    $(document).ready(function () {
      $("#menuBtn").on('click', function () {
          $('.nav-content').toggleClass('active');
          $(this).toggleClass('active');
      });
      $("#closeNavbar").on('click', function () {
          $('.nav-content').removeClass('active');
          $("#menuBtn").removeClass('active');
      });
    });
  }
};
</script>
